import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

import { ClaimsService, CookieService, Page, TrackingService } from '@frontend/vanilla/core';
import { HomepageResourceService } from '@pokercore/module/core';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

import { HomePageDownloadSectionService } from './homepage-downloadsection.service';

@Component({
    selector: 'homepage-downloadsection',
    templateUrl: 'homepage-downloadsection.component.html',
    imports: [CommonModule],
    providers: [HomePageDownloadSectionService],
})
export class HomePageDownloadSectionComponent implements OnInit {
    downloadSectionContent: any;
    allData: any;
    private destroy$ = new Subject<void>();
    playTechConfig: any;
    playTechLauncher: string;
    languageCode: string;

    constructor(
        private homePageService: HomepageResourceService,
        private tracking: TrackingService,
        private downloadSectionService: HomePageDownloadSectionService,
        private cookieService: CookieService,
        private claimsService: ClaimsService,
        private page: Page,
    ) {}
    ngOnInit() {
        this.languageCode = this.page.lang;

        // fetch playTech config from dynacon
        this.downloadSectionService
            .getInitValues()
            .pipe(
                tap((data) => console.log('Data received:', data)),
                takeUntil(this.destroy$),
            )
            .subscribe((data) => {
                this.playTechConfig = data || null;
            });

        this.downloadSectionContent = this.homePageService.dynamicContent.viewModel.contentItems.find((item: any) =>
            item.metadata.id.itemName.toLowerCase().includes('downloadsection'),
        );
    }

    buildPlayTechUrl() {
        if (this.playTechConfig && this.playTechConfig.playTechEnabled) {
            const postLoginValues = this.cookieService.getObject('mobileLogin.PostLoginValues') || {};
            const tempPartnerToken = postLoginValues.tempPartnerToken || '';
            //const accountId = this.user.accountId ?? '';
            const accountId = this.claimsService.get('http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier') ?? '';

            // Construct the playTechLauncher URL with query parameters from playTechConfig
            const { gameCodeName, casinoParam, clientPlatform, playMode, depositUrl, webLaunchUrl } = this.playTechConfig;
            const launchUrl = `${encodeURIComponent(webLaunchUrl)}?gameCodeName=${encodeURIComponent(gameCodeName)}&username=${encodeURIComponent(accountId)}&externalToken=${encodeURIComponent(tempPartnerToken)}&clientPlatform=${encodeURIComponent(clientPlatform)}&language=${encodeURIComponent(this.languageCode)}&playMode=${encodeURIComponent(playMode)}&casino=${encodeURIComponent(casinoParam)}&depositUrl=${encodeURIComponent(depositUrl)}`;
            this.playTechLauncher = decodeURIComponent(launchUrl);
            window.open(this.playTechLauncher, '_self');
        }
    }

    public onDownloadClick(event: any, downloadContent: any) {
        event.stopPropagation();
        this.tracking.triggerEvent('Event.Clicks', {
            'component.CategoryEvent': 'Download',
            'component.LabelEvent': 'Poker Homepage_Download',
            'component.ActionEvent': 'DOWNLOAD Click',
            'component.PositionEvent': 'Download',
            'component.EventDetails': 'CTA Name|' + downloadContent.titleLink.text,
            'component.URLClicked': downloadContent.titleLink.url,
            'component.LocationEvent': 'Download',
        });

        window.open(
            this.downloadSectionContent.titleLink.url,
            '_self', //teaser.secondCta.target
        );
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
